import React, { ReactElement } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Icon from '@bit/atd.web.icons'
import TextField from '@material-ui/core/TextField'
import colors from '@bit/atd.web.colors'

const useStyles = makeStyles({
  wrap: {
    position: 'relative',
    marginLeft: 'auto',
    flexBasis: '320px',
    '& .icon--magnify': {
      position: 'absolute',
      left: '16px',
      top: '50%',
      transform: 'translateY(-50%)',
      zIndex: 3,
    },
  },
  input: {
    '& .MuiOutlinedInput-root': {
      borderRadius: '3em',
      backgroundColor: colors.white,
    },
    '& .MuiInputBase-input': {
      height: '0.688em',
      paddingLeft: '40px',
    },
  },
})

type PropsType = {
  placeholder?: string
  onChange?: (item: any) => void
}

const Search = ({ placeholder, onChange }: PropsType): ReactElement => {
  const classes = useStyles()
  return (
    <div className={classes.wrap}>
      <Icon glyph="magnify" size={16} />
      <TextField
        fullWidth
        type="search"
        name="search"
        variant="outlined"
        placeholder={placeholder}
        className={classes.input}
        onChange={onChange}
      />
    </div>
  )
}

export default Search
